<script>
import Notification from '../reUse/Notification.vue';
import NaRazpolago from './Razpolozljivost_vnosi.vue';
import { i18n } from '@/i18n'
import sl from '@/Prevodi/Razpolozljivost-sl.json';
import en from '@/Prevodi/Razpolozljivost-en.json';
import it from '@/Prevodi/Razpolozljivost-it.json';
import {config} from "@/config";
import DropDown from "@/components/reUse/DropDown.vue";
export default {
  components: {
    DropDown,
    Notification,
    NaRazpolago
  },
  emits: ['odjava'],
  data() {
    return {
      prevodi: false,
      prikaz: (config.FullUser.lvl > 1) ? 'zapisi' : 'vnos',
      datum: null,
      uraOd: null,
      uraDo: null,
      Letala: [],
      dLetalo: false,
      plovilo: '',
      letaloId: null,
      osvezi: false,
      dodajanje: false,
      opomba: null,
      namen: 'm',
      //NOTIFICATION
      ShowNoti: false,
      text: '',
      types: '',
      user: config.FullUser
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.GetLetala();
  },
  methods: {
    Dodaj() {
      this.dodajanje = true;
      var podatki = new URLSearchParams();
      if(this.plovilo === '' || this.plovilo === null || this.letaloId === null) {
        this.text = this.$t('obvestila.praznoPlovilo');
        this.types = "Napaka";
        this.ShowNoti = true;
        this.dodajanje = false;
        $('#regLetala').removeClass('border-0').css('border', '1px solid red');
        setTimeout(()=>{
          $('#regLetala').removeAttr('style').addClass('border-0');
        }, 1000);
        return;
      }
      if(this.datum === null) {
        $('#datum').removeClass('border-0').css('border', '1px solid red');
        this.text = this.$t('obvestila.prazenDatum');
        this.types = "Napaka";
        this.ShowNoti = true;
        this.dodajanje = false;
        setTimeout(() => {
          $('#datum').removeAttr('style').addClass('border-0');
        }, 10000);
        return;
      }
      if (this.uraOd < this.uraDo) {
        podatki.append('letalo_id', this.letaloId);
        podatki.append('reg_letala', this.plovilo);
        podatki.append('datum', this.datum);
        podatki.append('ura_zacetka', this.uraOd);
        podatki.append('ura_konca', this.uraDo);
        podatki.append('opomba', (this.opomba !== null) ? this.opomba : null);
        axios.post('./api/razpolozljivost/letala/dodaj/', podatki, {withCredentials: true}).then((response) => {
          this.text = response.data.sporocilo;
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.datum = null;
          this.uraOd = null;
          this.uraDo = null;
          this.namen = 'm';
          this.opomba = null;
          this.osvezi = true;
          setTimeout(() => {
            this.osvezi = false;
          }, 500);
          this.dodajanje = false;
        }).catch((napaka) => {
          this.text = "Napaka pri vnosu";
          this.types = "Napaka";
          this.ShowNoti = true;
          this.dodajanje = false;
        });
      } else {
        $('#uraOd').removeClass('border-0').css('border', '1px solid red');
        this.text = this.$t('obvestila.casVnosa');
        this.types = "Napaka";
        this.ShowNoti = true;
        setTimeout(() => {
          $('#uraOd').removeAttr('style').addClass('border-0');
        }, 10000);
        this.dodajanje = false;
      }
    },
    GetLetala() {
      let app = this;
      axios
          .get("./api/sifranti/letala/izpis/")
          .then(function (response) {
            for (let i = 0; i < response.data.letala.length; i++) {
              if (response.data.letala[i].razpolozljivost) {
                app.Letala.push(response.data.letala[i]);
              }
            }
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    selectLetalo(id) {
      let letalo = this.Letala.find(l => l.id === id);
      if (letalo) {
        this.plovilo = letalo.registracija;
        this.letaloId = letalo.id
        this.dLetalo = false; // Zapri dropdown po izbiri
      }
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
  }
}
</script>
<template>
  <div class="pregled-povrsin-container" v-if="prevodi">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{$t('main.nazaj')}}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{$t('main.title')}}</h1>
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" v-if="user.lvl <= 1" :class="{'active': prikaz === 'vnos'}" @click="prikaz = 'vnos'" data-umami-event="Razpolozljivost-vnos">
              <i class="fas fa-edit"></i>
              <span>{{$t('nav.vnos')}}</span>
            </button>
            <button class="nav-tab hover-rdeca" :class="{'active bg-rdeca': prikaz === 'zapisi'}" @click="prikaz = 'zapisi'" data-umami-event="Razpolozljivost-zapisi">
              <i class="fas fa-list"></i>
              <span>{{$t('nav.zapisi')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container p-2" v-show="this.prikaz === 'vnos'">
      <Transition name="fade">
        <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
      </Transition>
      <div class="row">
        <!-- DATUM -->
        <div class="col-6">
          <div class="container">
            <div class="label-date p-2 col-6">{{$t('labelsR.datum')}}</div>
            <input class="input border-0 rounded-4 p-2 fs-5 mt-4" type="date" id="datum" v-model="datum" required />
          </div>
        </div>
        <!-- LETALO -->
        <div class="col-6">
          <div class="container">
            <div class="label-date p-2 col-6 d-flex justify-content-between">
              {{$t('labelsR.registracija')}}
              <button v-if="plovilo !== ''" class="btn btn-sm btn-outline-warning border-warning" @click.prevent="plovilo = ''; letaloId = null">{{$t('buttons.brisiIzbiro')}}</button>
            </div>
            <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
              <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
              <i v-show="dLetalo" class="fas fa-chevron-down"></i>
            </div>
            <button class="input border-0 rounded-4 fs-5" id="regLetala" @click.prevent="OpenLetalo">{{plovilo}}</button>
            <transition name="fade">
              <drop-down @letalo="selectLetalo" :data="Letala" type="letalo" class="drop-down-btn" id="registracijadd" v-if="dLetalo" />
            </transition>
          </div>
        </div>
      </div>
      <div class='row'>
        <!-- URA OD -->
        <div class="col-6">
          <div class="container">
            <div class="label-date p-2 col-6">{{$t('labelsR.uraOd')}}</div>
            <input class="input border-0 rounded-4 p-2 fs-5" type="time" id="uraOd" v-model="uraOd" required />
          </div>
        </div>
        <!-- URA DO -->
        <div class="col-6">
          <div class="container">
            <div class="label-date p-2 col-6">{{$t('labelsR.uraDo')}}</div>
            <input class="input border-0 rounded-4 p-2 fs-5" type="time" id="uraDo" v-model="uraDo" required />
          </div>
        </div>
      </div>
      <div class='row'>
        <!-- OPOMBA -->
        <div class="col-6">
          <div class="container">
            <div class="row d-flex">
            <div class="label-date ms-2 p-2 col-6">{{$t('labelsR.opomba')}} </div>
            <div class="label-date p-2 col-4 text-end">
              <span class="opomba-text" :class="{'text-danger': this.opomba !== null && this.opomba.length >= 90}">{{ (this.opomba !== null) ? this.opomba.length : 0}} / 100</span>
            </div>
            </div>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="opomba" maxlength="100" v-model="opomba" required />
          </div>
        </div>
      </div>
      <div class='row'>
        <div class='col-xl-6'></div>
        <div class='col-xl-6'>
          <div class='container mt-4 mt-md-5'>
            <button @click.prevent="Dodaj()" :disabled="dodajanje" class="btn btn-primary border-0 rounded-4 w-100" data-umami-event="Razpolozljivost-vnos-dodajanje">{{$t('buttons.vnesiZapis')}} <i class="fas fa-plus" :class="{'fa-spin': dodajanje}"></i></button>
          </div>
        </div>
      </div>
    </div>
    <na-razpolago v-show="this.prikaz === 'zapisi'" :osvezi="osvezi" :user="user" :letala="Letala.map(letalo => letalo.registracija)" @odjava="$emit('odjava')"/>
  </div>
</template>
<style>
  .opomba-text {
    font-size: 12px;
    color: gray;
  }
</style>